import { ExternalLinks } from '_constants/externalLinks/type'

const faqDomainUrl = 'https://faq.blank.app/hc/fr'

export const BLANK_EXTERNAL_LINKS_FR: ExternalLinks = {
  cguLink: 'https://www.blank.app/documents-legaux/cgu-Plateforme-de-Gestion',
  bankingOrganizationPrivacyPolicyLink:
    'https://www.blank.app/documents-legaux/politique-protection-des-donnees',
  brandPrivacyPolicyLink: '',
  appStoreLink:
    'https://apps.apple.com/fr/app/blank-lapp-des-ind%C3%A9pendants/id1522046776',
  googlePlayLink:
    'https://play.google.com/store/apps/details?id=app.blank.mobile&hl=fr',
  faq: faqDomainUrl,
  mandateSepa: `${faqDomainUrl}/articles/41778796546961-Comment-identifier-un-pr%C3%A9l%C3%A8vement-sepa-interentreprise`,
  invoicingFaq: `${faqDomainUrl}/articles/41285243117457-Comment-puis-je-cr%C3%A9er-une-facture-ou-un-devis`,
  requestHelp: `${faqDomainUrl}/articles/41397960049425-Comment-fonctionne-notre-service-client`,
  contactAdvisorPage: 'https://www.blank.app/contact',
  rcProInfo:
    'https://www.blank.app/assurance-professionnelle/responsabilite-civile-professionnelle',
  decadeGuaranteeInfo:
    'https://www.blank.app/assurance-professionnelle/assurance-decennale',
  multiriskInfo:
    'https://www.blank.app/assurance-professionnelle/assurance-multirisque-professionnelle',
  legalPlaceCompany: 'https://heyflow.id/blank-creation-corpo',
  helpNonDiffusible: `${faqDomainUrl}/articles/40798937648529-%C3%80-l-%C3%A9tape-Recherchez-votre-entreprise-mon-SIREN-SIRET-n-est-pas-retrouv%C3%A9-que-faire`,
  helpNonEligible: faqDomainUrl,
  helpNonAllowed: `${faqDomainUrl}/articles/40848544847633-Quelles-sont-les-conditions-pour-ouvrir-un-compte`,
  helpBeneficialOwners: `${faqDomainUrl}/articles/40799074627089-Qu-est-ce-qu-un-b%C3%A9n%C3%A9ficiaire-effectif`,
  urssaf: {
    portal: 'http://autoentrepreneur.urssaf.fr/',
    microEntrepreneurs:
      'https://www.autoentrepreneur.urssaf.fr/portail/accueil/sinformer-sur-le-statut/lessentiel-du-statut.html',
    socialContributions: 'http://www.aquoiserventlescotisations.urssaf.fr/',
    sepaMandate: 'https://www.blank.app/compte-professionnel/mandat-sepa',
    faq: faqDomainUrl,
    tdaeStatusHelp: faqDomainUrl,
    tdaePaymentAuthorization: faqDomainUrl,
    tou: 'https://www.blank.app/documents-legaux/cgu-tierce-declaration-urssaf',
  },
  faqWhoIsBlankFor: faqDomainUrl,
  psdFAQ: faqDomainUrl,
  fatcaCGU:
    'https://cdn.prod.website-files.com/5e2f01f286f417acc730dafc/66388b4f1e8a3bb48cc4399e_CGU%20-%20Compte%20de%20paiement.pdf',
  legalLink: 'https://www.blank.app/documents-legaux',
  supportEmail: 'support@blank.app',
  securityEmail: 'securite@blank.app',
  leadEmail: '',
  sepaTransfer: faqDomainUrl,
  compareOffers: 'https://www.blank.app/tarifs',
  touBankAccount:
    'https://www.blank.app/documents-legaux/cgu-compte-de-paiement',
  kycHelp: faqDomainUrl,
  legalStatus: 'https://www.blank.app/creer-son-entreprise/statut-juridique',
  capitalDeposit: 'https://www.blank.app/depot-de-capital',
  discoverManagementToolsOffer: '',
  sponsorshipFAQ: `${faqDomainUrl}/articles/40787740716049-Comment-fonctionne-le-parrainage-chez-Blank`,
  priceBrochure:
    'https://assets.website-files.com/5e2f01f286f417166130daf6/63369e10f798ee4ae0d25065_Plaquettetarifaire_Blank_compressed-30%3A09%3A22.pdf',
  changeNonDiffusibleCompany: 'https://statut-diffusion-sirene.insee.fr',
  sponsorshipInvitationLink: 'https://blank.app/offre-parrainage',
  transparencyPolicy: '',
  requestDeviceResetFAQ: `${faqDomainUrl}/articles/41862389981457-Comment-l-authentification-forte-s%C3%A9curise-t-il-mon-compte`,
  accountClosingFaq: `${faqDomainUrl}/articles/40856485788817-Comment-cl%C3%B4turer-mon-compte`,
  bankScamPreventionLink: '',
  transferFAQ: `${faqDomainUrl}/articles/41281896632977-Sous-quels-d%C3%A9lais-mon-virement-sera-t-il-re%C3%A7u`,
  atecoCodeFAQ: '',
  partitaIVACertificateFAQ: '',
}
